import { Pipe, PipeTransform } from '@angular/core';

/**
 * Gibt den übergebenen boolean-Wert besser lesbar als Ja/Nein zurück
 */
@Pipe({name: 'readableShippingStatus' })
export class readableShippingStatusPipe implements PipeTransform {
  transform(status: number): string {
    const statusMap = {
      0: 'Anstehend',
      50: 'Packliste',
      100: 'Vorbereitet',
      200: 'In Lieferung',
      300: 'Geliefert',
      400: 'Rücksendung',
      500: 'Storniert'
    };

    if (!statusMap.hasOwnProperty(status)) {
      return 'Nicht definiert';
    }

    return statusMap[status];
  }
}